<template>
  <div class="video-container">
    <!-- 根据 showMask 决定是否显示蒙版 -->
    <div v-if="showMask" class="mask" @click="closeVideoAndMask">
      <!-- 这里可以添加蒙版内部元素，例如提示信息等 -->
    </div>
    <!-- 根据 isOpen 决定是否显示视频播放器 -->
    <div class="videoBox">
      <video-player
        v-if="isOpen"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
      >
      </video-player>
      <div class="mask-content close-button" @click="closeVideoAndMask">
        <i v-if="isOpen" class="el-icon-circle-close"></i>
      </div>
    </div>
    <!-- <button v-if="isOpen" class="close-button" @click="closeVideoAndMask">关闭</button> -->

    <!-- 根据 isOpen 决定是否显示关闭按钮 -->
  </div>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

export default {
  components: {
    videoPlayer,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    showMask: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      playerOptions: {
        sources: [
          {
            type: "video/mp4",
            src: require("../assets/mp4/1.mp4"),
          },
        ],
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: true, // 如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        width:1000,
        height: 600,
        aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controls: true,
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  created() {
    console.log("VideoPlayerWithMask component created");
  },
  mounted() {
    console.log("VideoPlayerWithMask component mounted");
  },
  watch: {
    isOpen(newValue) {
      console.log("isOpen changed to:", newValue);
      if (newValue) {
        this.openVideo();
      } else {
        this.closeVideo();
      }
    },
  },
  methods: {
    openVideo() {
      this.$nextTick(() => {
        const player = this.$refs.videoPlayer.player;
        if (player) {
          player.play();
        } else {
          console.error("Video player instance not found");
        }
      });
    },
    closeVideo() {
      this.$nextTick(() => {
        const player = this.$refs.videoPlayer.player;
        if (player) {
          try {
            player.pause();
            player.currentTime(0);
          } catch (error) {
            console.error("Failed to pause video:", error);
          }
        } else {
          console.error("Video player instance not found");
        }
      });
      this.$emit("close");
    },
    closeVideoAndMask() {
      this.closeVideo();
      this.$emit("toggle-mask");
    },
    onPlayerPlay(event) {
      console.log("视频播放事件触发", event);
    },
    onPlayerPause(event) {
      console.log("视频暂停事件触发", event);
    },
  },
};
</script>

<style scoped>
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  cursor: pointer;
  pointer-events: none;
}

.mask-content {
  color: white;
  font-size: 20px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.video-player {
  position: relative;
  z-index: 4;
  pointer-events: auto; /* 确保视频播放器可以响应点击事件 */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  pointer-events: auto;
}

.mask-content {
  color: aliceblue;
  font-size: 40px;
  cursor: pointer;
}
.videoBox{
    width: 800px;
  }

/deep/ #download{
  display: none !important;
}
</style>  
<style>
/deep/ #download{
  display: none !important;
}

@media screen and (max-width: 1680px) {
  html {
    font-size: 20px;
  }

}

@media screen and (max-width: 1280px) {
  html {
    font-size: 10px;
  }
}

@media screen and (max-width: 960px) {
  html {
    font-size: 10px;
  }

}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

}
</style>  